import { compact } from "lodash";

export type Profile = {
  givenName: string | null;
  familyName: string | null;
  externalImageUrl?: string | null;
};

export const getFullName = (owner: Profile | null | undefined) =>
  compact([owner?.givenName, owner?.familyName]).join(" ");

export const getInitials = (owner: Profile | null | undefined) =>
  compact([owner?.givenName?.[0], owner?.familyName?.[0]]).join("");
